import styled from '@emotion/styled';

export const To = styled.h4`
  text-transform: none;
  display: block;
`;

export const CustomDateMessage = styled.h4`
  margin: 24px 0 !important;
`;

export const RangeStartDate = styled.div`
  .date {
    margin-bottom: 8px !important;
    padding-bottom: 0 !important;
  }
`;

export const RangeEndDate = styled.div`
  .date {
    margin-top: 8px !important;
    padding-top: 0 !important;
  }
`;
